
import json from '#shared/util/json.js';
import appError from '#shared/util/appError.js';
import logger from '#shared/util/logger.js';
import readArguments from '#shared/util/readArguments.js';

import asyncCall from './asyncCall.js';

/**
 * Login user by ticket from the account API
 * @param {object} options
 * @param {string} options.email MyAccount account / billing email
 * @param {object} options.tickets Tokens for the given session
 * @param {string} options.tickets.NVAT Ticket issued by MyAccount when creating the account so we can use it for logging
 * @param {string} [options.firstName=""] MyAccount account / billing first name
 * @param {string} [options.lastName=""] MyAccount account / billing last name
 * @param {boolean} [options.verified=false] MyAccount account verification status
 * @returns {Promise}
 */
export default function loginByTicket({ email, tickets = {}, firstName = '', lastName = '', verified = false } = {}) {
	if (typeof email === 'string' && typeof tickets.NVAT === 'string') {
		const appCall = 'app.lif.account.set_account_info';
		return new Promise((resolve) => {
			asyncCall(appCall, ([, error]) => {
				if (error) {
					logger.warn({
						code: 'CLIENT',
						origin: appCall,
						detail: json.parse(error) || {}
					});
				} else {
					resolve();
				}
			}, {
				email,
				first_name: firstName,
				last_name: lastName,
				verified,
				tickets
			});
		});
	} else {
		throw appError('Invalid method arguments to loginByTicket', {
			code: 'APP_FRONTEND_UTIL',
			origin: 'loginByTicket',
			detail: readArguments(arguments) // @todo update detail structure
		});
	}
}
